<template>
  <v-dialog v-model="dialog" :max-width="maxWidth" persistent scrollable>
    <template v-slot:activator="{ on }">
      <span v-if="type === 'text'" class="link right-text" v-on="on">{{ label }}</span>
      <div v-else-if="type === 'input'" v-on="on">
        <mf-search :disabled="disabled" :value="textFieldValue" hide-details />
      </div>
      <span v-else v-on="on">
        <mf-button :loading="loading" :disabled="disabled" :label="label" />
      </span>
    </template>
    <v-card>
      <v-card-title>
        <span class="mf-h6 primary-text">Selecionar campanhas</span>
      </v-card-title>
      <v-card-text class="px-3">
        <mf-search v-model.lazy="search" class="mx-2" placeholder="Buscar campanha" hide-details />

        <select-campaigns-table
          v-model="selectedCampaigns"
          :showMessage="showMessage"
          :singleCheckbox="singleCheckbox"
          :search="search"
          :mode="mode"
          :status="status"
          :default-table-sort-by="defaultTableSortBy"
          :default-table-sort-desc="defaultTableSortDesc"
          :include-maria-campaign="includeMariaCampaign"
          :only-maria-campaign="onlyMariaCampaign"
        />
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <mf-action-buttons
          :primary-button="{
            text: 'Confirmar',
            action: save,
            isVisible: true,
            isDisabled: disableSave,
            tooltip: tooltipPrimaryButton,
            tooltipMessage: tooltipPrimaryButtonMessage,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: closeDialog,
            isVisible: true,
          }"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SelectCampaignsTable from './SelectCampaignsTable'
import { statusCampaignArrayValidator } from '@/helpers/propValidators.js'

export default {
  name: 'SelectCampaigns',
  components: {
    SelectCampaignsTable,
  },
  props: {
    selected: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isText: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
      validator: (value) => ['', 'text', 'input'].indexOf(value) !== -1,
    },
    showMessage: {
      type: Boolean,
      default: false,
    },
    singleCheckbox: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Selecionar campanhas',
    },
    status: {
      type: Array,
      default: () => [],
      validator: statusCampaignArrayValidator,
    },
    mode: {
      type: Array,
      default: () => ['SMS', 'EMAIL', 'WHATSAPP', 'PUSH'],
    },
    defaultTableSortBy: {
      type: String,
      default: '',
    },
    defaultTableSortDesc: {
      type: Boolean,
      default: false,
    },
    includeMariaCampaign: {
      type: Boolean,
      default: false,
    },
    onlyMariaCampaign: {
      type: Boolean,
      default: false,
    },
    disableSave: {
      type: Boolean,
      default: false,
    },
    tooltipPrimaryButton: {
      type: Boolean,
      default: false,
    },
    tooltipPrimaryButtonMessage: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    selectedCampaigns: [],
    dialog: false,
    search: null,
  }),
  computed: {
    maxWidth() {
      return this.showMessage ? '1200px' : '800px'
    },
    textFieldValue() {
      return this.selectedCampaigns.map((campaign) => campaign.title).join(', ')
    },
  },
  watch: {
    dialog(dialog) {
      if (dialog) this.selectedCampaigns = this.selected
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false
    },
    save() {
      this.$emit('update:selected', this.selectedCampaigns)
      this.dialog = false
    },
  },
}
</script>
<style lang="scss" scoped>
.message-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
